import { createContext, useContext, useState, useEffect } from "react";
import Url, { TQueryParams } from "../Url";
import Path, {TQueryParamsNull} from "./Path";

export interface IPathContext {
    path:string;
    query:TQueryParams;
    setPath:(url:string)=>void;
    setQuery:(query:TQueryParamsNull)=>void;
}
const PathContext = createContext<IPathContext>({path:"",query:{},setPath:()=>{},setQuery:()=>{}})
const g_path = new Path().parse(document.location.href)

export const usePath = () => useContext(PathContext)

export default function PathProvider(props:{children:any}){
    const [path,_setPath] = useState<string>(g_path.path);
    const [query,_setQuery] = useState<TQueryParams>(g_path.query);

    useEffect(() => {
        const _update = (url:Path) => {
          _setPath(url.path)
          if (JSON.stringify(query)!=JSON.stringify(url.query)) _setQuery({...url.query})
        }
        g_path.addListener("change", _update)
        return () => {g_path.removeListener("change", _update)}
      },[])
    const setPath = (url:string|Url) => g_path.set(url)
    const setQuery = (query:TQueryParamsNull) => { g_path.setParams(query); _setQuery({...g_path.query}) }

    return <PathContext.Provider value={{path,query,setPath,setQuery}}>
        {props.children}
    </PathContext.Provider>
}